import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ standalone: true, name: 'enabledFeatures' })
export class EnabledFeaturesPipe implements PipeTransform {
    transform(items: Array<any>): Array<any> {
        return items.filter(item => item.isEnabled);
    }
  }

@Pipe({ standalone: true, name: 'availableProgramOptions' })
export class AvailableProgramOptionsPipe implements PipeTransform {
  transform(items: Array<any>): Array<any> {
      return items.filter(item => item.isEnabled && item.canJoin);
  }
}

@Pipe({ standalone: true, name: 'ldcOptions' })
export class LdcOptionsPipe implements PipeTransform {
  transform(items: Array<any>): Array<any> {
    return items.filter(item => {
      if (!item.isEnabled || item.programOptions.length === 0){
        return false;
      } else{
          const options = item.programOptions.filter(po => po.isEnabled && po.canJoin);
          return options != null && options.length > 0;
      }
    })
  }
}

@Pipe({ standalone: true, name: 'transactionType' })
export class TransactionTypePipe implements PipeTransform {
    transform(item: any): any {     
        if (item != null && item.details != null) {
            return item.details;
        }

        return null;
    }
}
